import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import PagesLayout from './PagesLayout';

const OchranaOsobnychUdajov = ({ t }) => (
  <PagesLayout className="ochrana">
    <h1>{t('Ochrana osobných údajov')}</h1>
    <p>
      {t(
        'Spoločnosť Peer2Peer, s.r.o., prevádzkovateľ portálu www.majak.sk, zabezpečuje ochranu osobných údajov v súlade so zákonom č. 122/2013 Z.z. o ochrane osobných údajov a o zmene a doplnení niektorých zákonov v znení neskorších predpisov (ďalej len „zákon“). Osobné údaje poskytujú klienti do www.majak.sk na základe § 10 zákona. Účelom spracovania osobných údajov klientov je spracovanie osobných údajov podľa § 10 zákona za účelom plnenia zmluvných a predzmluvných vzťahov.'
      )}
    </p>
    <p>
      {t(
        'Klient je podľa § 16 ods. 1 zákona povinný poskytnúť do informačného systému iba pravdivé osobné údaje. V prípade zmeny je povinný tieto zmeny bez zbytočného odkladu nahlásiť spoločnosti Peer2Peer, s.r.o. - prevádzkovateľovi portálu www.majak.sk.'
      )}
    </p>
    <p>
      {t(
        'Spoločnosť Peer2Peer, s.r.o. spracúva osobné údaje klienta v prípade, keď sa klient zaregistruje na stránke www.majak.sk. Spoločnosť Peer2Peer, s.r.o. z dôvodov dodržania predzmluvných a zmluvných povinností overuje identitu klienta aj všetky poskytnuté údaje a tiež aj na vyhľadávanie dlžníkov, v prípade nesplácania pôžičky a na vymáhanie pohľadávok. Na overenie klient poskytuje súhlas.'
      )}
    </p>
    <p>
      {t(
        'Osobné údaje klienta spoločnosť Peer2Peer, s.r.o.  poskytne tretím osobám len v súlade s osobitnými predpismi.'
      )}
    </p>
  </PagesLayout>
);

OchranaOsobnychUdajov.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(OchranaOsobnychUdajov);



// WEBPACK FOOTER //
// ./src/features/pages/OchranaOsobnychUdajov.js